import { useMutation } from '@apollo/client';
import { Arrange } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  PROFILE_FOLLOWED,
  PROFILE_FOLLOW_SUGGESTION_DISPOSITIONED,
} from 'constants/events';
import { FollowStreamType } from 'constants/follows';
import { MemberPropertyEnum } from 'constants/memberProperties';
import ToggleFollowingProfile from 'creators/follows/ToggleFollowingProfile.graphql';
import { selectCurrentUser } from 'selectors/user';
import { track } from 'utilities/analytics';

import { useUpdateMemberProperty } from 'hooks/memberProperties';

import {
  AddSuggestedFollow,
  RemoveSuggestedFollow,
} from './ToggleSuggestedFollow';

import styles from './styles.module.less';

const SuggestedProfileFollow = ({ profile, ProfileLink, declinedStreams }) => {
  const user = useSelector(selectCurrentUser);

  const [followProfile] = useMutation(ToggleFollowingProfile, {
    refetchQueries: ['GetUserFollowsProfile', 'GetUserFollowedStreams'],
    awaitRefetchQueries: true,
  });

  const { updateMemberProperty } = useUpdateMemberProperty(
    MemberPropertyEnum.DECLINED_SUGGESTED_FOLLOW_STREAMS,
    { refetchQueries: ['GetSuggestedStreams'] }
  );

  const addProfile = () => {
    followProfile({ variables: { follow: true, profileId: profile.user.id } });

    track(PROFILE_FOLLOWED, {
      user_id: user.id,
      profile_id: profile.user.id,
      context_page_path: window.location.pathname,
    });

    track(PROFILE_FOLLOW_SUGGESTION_DISPOSITIONED, {
      user_id: user.id,
      profile_user_id: profile.user.id,
      surface: 'sidebar',
      is_accepted: true,
    });
  };

  const removeProfile = () => {
    updateMemberProperty([
      ...declinedStreams,
      {
        type: FollowStreamType.USER_PROFILE,
        value: profile.user.id,
      },
    ]);

    track(PROFILE_FOLLOW_SUGGESTION_DISPOSITIONED, {
      user_id: user.id,
      profile_user_id: profile.user.id,
      surface: 'sidebar',
      is_accepted: false,
    });
  };

  return (
    <ProfileLink
      profile={profile}
      className={styles.suggestedStream}
      actionElement={
        <Arrange gap="xxsmall">
          <AddSuggestedFollow onClick={addProfile} />
          <RemoveSuggestedFollow onClick={removeProfile} />
        </Arrange>
      }
    />
  );
};

export default SuggestedProfileFollow;
